class localStorageManager {
  constructor(storeName, defaultExpireMinutes = null) {
    this.storeName = storeName
    this.defaultExpireMinutes = defaultExpireMinutes
  }

  // --- Internal helpers ---

  _loadStore() {
    const raw = window.localStorage.getItem(this.storeName)

    if (!raw) return { items: {} }

    try {
      return JSON.parse(raw)
    } catch {
      return { items: {} }
    }
  }

  _saveStore(store) {
    window.localStorage.setItem(this.storeName, JSON.stringify(store))
  }

  _isExpired(item, expireMinutes) {
    if (!item._addedAt || !expireMinutes) return false

    const now = new Date()
    const added = new Date(item._addedAt)
    const diffMinutes = Math.floor((now - added) / 1000 / 60)

    return diffMinutes >= expireMinutes
  }

  _purgeExpired(store) {
    const expireMinutes = this.defaultExpireMinutes
    if (!expireMinutes) return store

    for (const key in store.items) {
      if (this._isExpired(store.items[key], expireMinutes)) {
        delete store.items[key]
      }
    }

    this._saveStore(store)

    return store
  }

  // --- Public API ---

  set(key, data) {
    const store = this._loadStore()

    store.items[key] = {
      data,
      _addedAt: new Date().toISOString(),
    }

    this._saveStore(store)
  }

  get(key, expireMinutesOverride = null) {
    let store = this._loadStore()

    // purge expired globally first
    store = this._purgeExpired(store)

    const item = store.items[key]
    if (!item) return null

    if (expireMinutesOverride !== null) {
      if (this._isExpired(item, expireMinutesOverride)) {
        delete store.items[key]
        this._saveStore(store)
        return null
      }
    }

    return item.data
  }

  remove(key) {
    const store = this._loadStore()
    delete store.items[key]
    this._saveStore(store)
  }

  clear() {
    window.localStorage.removeItem(this.storeName)
  }
}

export default localStorageManager
